// extracted by mini-css-extract-plugin
export default {"video__title":"LessonModal_video__title__dtW5a","photo__title":"LessonModal_photo__title__TrHvt","video":"LessonModal_video__ttLiq","video__icon":"LessonModal_video__icon__TOeEI"};